import React, { useEffect } from 'react';
import { CSVLink } from 'react-csv';
import SensorGrid from '../components/SensorGrid';
import { useSensorData } from '../hooks/useSensorData';
import '../components/SensorContainer.css'; // CSS import 추가

const SensorContainer = () => {
  const {
    sensorData,
    csvExportData,
    startDate,
    endDate,
    filterType,
    topic,
    loading,
    setStartDate,
    setEndDate,
    setFilterType,
    setMachine,
    loadData,
    exportFilteredData,
    csvLinkRef
  } = useSensorData();

  useEffect(() => {
    loadData();
  }, [loadData]);

  const now = new Date();
  const formattedDateTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;

  const handleSearch = () => {
    loadData();
  };

  return (
    <div className="container">
      {/* 필터 */}
      <div className="filterContainer">
        <label className="filterLabel">
          시작날짜:
          <input
            type="date"
            value={startDate || now.toISOString().slice(0, 10)}
            onChange={(e) => setStartDate(e.target.value)}
            className="filterInput"
          />
        </label>
        <label className="filterLabel">
          종료날짜:
          <input
            type="date"
            value={endDate || now.toISOString().slice(0, 10)}
            onChange={(e) => setEndDate(e.target.value)}
            className="filterInput"
          />
        </label>
        <label className="filterLabel">
          데이터 타입:
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            className="filterSelect"
          >
            <option value="all">전체</option>
            <option value="pass">정상 데이터</option>
            <option value="fail">이상 데이터</option>
          </select>
        </label>
        <label className="filterLabel">
          설비명:
          <input
            type="text"
            value={topic}
            onChange={(e) => setMachine(e.target.value)}
            placeholder="예: sensor1"
            className="filterInput"
          />
        </label>
        <button
          onClick={handleSearch}
          disabled={loading}
          className={`button buttonPrimary ${loading ? 'buttonDisabled' : ''}`}
        >
          {loading ? '검색중...' : '검색'}
        </button>
        <CSVLink
          data={csvExportData}
          filename={`sensor_data_${filterType}_${formattedDateTime}.csv`}
          className="hidden"
          ref={csvLinkRef}
        />
        <button
          onClick={exportFilteredData}
          disabled={loading}
          className={`button buttonPrimary ${loading ? 'buttonDisabled' : ''}`}
        >
          {loading ? '검색중...' : '조건으로 바로 CSV 내보내기'}
        </button>
      </div>

      {/* 데이터 요약 + CSV 버튼 라인 */}
      <div style={{ width: 'calc(100% - 30px)', margin: '0 15px' }}>
        <div
          className="statusSummary"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
          }}
        >
          <div>
            <span>전체: {sensorData.length.toLocaleString()}건</span>
            <span className="statusPass">
              정상: {sensorData.filter((d) => d.ispass).length.toLocaleString()}건
            </span>
            <span className="statusFail">
              이상: {sensorData.filter((d) => !d.ispass).length.toLocaleString()}건
            </span>
          </div>

          <CSVLink
            data={sensorData}
            filename={`sensor_data_${filterType}_${formattedDateTime}.csv`}
            className="button buttonSuccess"
          >
            그리드 CSV 내보내기
          </CSVLink>
        </div>
      </div>

      <div className="tableScrollWrapper">
        <SensorGrid data={sensorData} />
      </div>
    </div>
  );
};

export default SensorContainer;
